import { c as _c } from "react-compiler-runtime";
import React from "react";
import { AlertCircle } from "../../icons/line.js";
import * as styles from "./ErrorIcon.css.js";
import { jsx as _jsx } from "react/jsx-runtime";
const ErrorIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx(AlertCircle, {
      className: styles.errorIcon
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ErrorIcon;
//# sourceMappingURL=ErrorIcon.js.map